import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  currentBatchId: string | null;
  setCurrentBatchId: (id: string | null) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      currentBatchId: null,
      setCurrentBatchId: (id) => set({ currentBatchId: id }),
    }),
    { name: 'kp-ui' }
  )
);
